import React from "react";
import ContactMarquee from "./ContactMarquee";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore</title>
        <meta name="description" content="Learn about Columbiaa Hospital, the best multi-speciality hospital in Kasturi Nagar, Bangalore. Our mission, vision, leadership, and commitment to compassionate healthcare. Expert neurosurgeons, advanced technology, and world-class medical facilities." />
        <meta name="keywords" content="Columbiaa Hospital, about Columbiaa Hospital, best multi-speciality hospital, hospital in Kasturi Nagar, hospital in Bangalore, multi-speciality hospital Bangalore, neurosurgeon Bangalore, brain surgeon Bangalore, Dr H V Satish Babu, Managing Director Pavan Kumar, Advanced healthcare Bangalore, mission healthcare hospital, vision hospital Bangalore, compassionate care hospital, medical Director hospital, integrated healthcare provider, clinical success hospital, patient-centred care hospital, advanced technology hospital, healthcare innovation Bangalore, hospital leadership, hospital management, quality healthcare Bangalore, hospital near me, top hospital Bangalore, multi-speciality hospital near me, Columbiaa Hospital Kasturi Nagar, healthcare community, hospital excellence Bangalore" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="About Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore" />
        <meta property="og:description" content="Learn about Columbiaa Hospital's mission, vision, and leadership. The best multi-speciality hospital in Kasturi Nagar, Bangalore with expert neurosurgeons and advanced healthcare." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/about-us" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/about-us" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>
      {/* <!--Page Title--> */}
      <section
        className="page-title"
        style={{
          backgroundImage: "url(assets/images/background/page-title.jpg)",
          overflowX: "hidden",
        }}
        aria-label="About Columbiaa Hospital - Leading Multi-Speciality Hospital in Bangalore"
      >
        <div
          class="pattern-layer"
          style={{
            backgroundImage: "url(assets/images/shape/pattern-35.png)",
          }}
        ></div>
        <div class="auto-container">
          <div class="content-box">
            {/* <!-- contactinfo-section --> */}
            <section class="contact-page-section">
              <div
                className="auto-container"
                aria-label="Columbiaa Hospital Community Commitment Section"
              >
                <div className="row clearfix" style={{ marginTop: "-120px" }}>
                  <div
                    className="col-lg-6 col-md-12 col-sm-12 content-column"
                    style={{ marginTop: "30px" }}
                    data-aos="fade-right"
                    aria-label="Columbiaa Mission Statement"
                  >
                   <div 
  id="content_block_6"
  aria-labelledby="contentBlock6Title"
  title="At Columbiaa Hospital - Humility and Healthcare Commitment"
>
  <div className="content-box">
    <div className="sec-title pt-5">
      <h2 
        style={{ color: "white", fontWeight: "300" }}
        id="contentBlock6Title"
        aria-label="Humility and Healthcare Ethos at Columbiaa Hospital"
        title="Humility and Healthcare Commitment at Columbiaa Hospital"
      >
        At Columbiaa, humility is integral to our ethos.
      </h2>
      <p 
        style={{ color: "white" }}
        aria-label="Mission and Objective of Columbiaa Hospital"
        title="Mission and Objective of Columbiaa Hospital"
      >
        Our primary objective is to positively impact lives by promoting health across both Urban and Rural, underprivileged communities. Columbiaa Hospital is committed to transcending conventional therapeutic care by emphasising preventive measures, ensuring the delivery of exceptional healthcare services to the community.
      </p>
      <br />
    </div>
  </div>
</div>

                  </div>

                  <div
  className="col-lg-6 col-md-12 col-sm-12 form-column"
  data-aos="fade-left"
  aria-label="Image showing Columbiaa's healthcare outreach efforts"
  title="Columbiaa's Healthcare Outreach Programme"
>
  <div
    className="form-inner"
    style={{
      borderRadius: "12px",
      padding: "15px",
    }}
  >
    <img
      src="assets/images/about/op.jpeg"
      alt="Columbiaa Hospital "
      aria-label="Columbiaa Hospital "
      title="Columbiaa Hospital "
    />
  </div>
</div>

                </div>
              </div>
            </section>
            {/* <!-- contactinfo-section end --> */}
          </div>
        </div>
      </section>

      {/* <!--End Page Title--> */}

      <div className="aboutus" style={{ overflowX: "hidden" }}>
        <div
          className="pattern-layer"
          style={{
            backgroundImage: "url(assets/images/shape/pattern-5.png)",
          }}
        ></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="row clearfix">
            <div
  className="col-lg-6 col-md-12 col-sm-12 content-column"
  data-aos="fade-right"
  aria-label="Columbiaa Hospital, Kasturi Nagar, Bangalore - Welcome"
  title="Columbiaa Hospital, Kasturi Nagar, Bangalore"
>
  <div id="content_block_2">
    <div className="content-box centred">
      <figure className="image-box">
        <img
          src="assets/images/resource/hospital-img.jpg"
          alt="Columbiaa Hospital located in Kasturi Nagar, Bangalore, providing quality healthcare services"
          style={{
            border: "3px solid rgb(83,160,212)",
            borderRadius: "0 52px",
          }}
          aria-label="Columbiaa Hospital, Kasturi Nagar, Bangalore, healthcare services"
          title="Welcome to Columbiaa Hospital, Kasturi Nagar, Bangalore"
        />
      </figure>
    </div>
  </div>
</div>

<div
  className="col-lg-6 col-md-12 col-sm-12 content-column pl-5"
  data-aos="fade-left"
  aria-label="About Columbiaa Hospital - Integrated Healthcare Provider"
  title="Columbiaa Multi Specialty Hospital - Known for Clinical Success Rates and Superior Technology"
>
  <div id="content_block_3">
    <div className="content-box">
      <div className="sec-title">
        {/* <span className="top-title">
          About Columbiaa Hospital
        </span> */}
        <h3
          aria-label="Columbiaa Hospital Known for Clinical Success Rates and Superior Technology"
          title="Columbiaa Multi Specialty Hospital with Exceptional Clinical Success Rates"
        >
          Our hospital today is known as an integrated healthcare provider with its exceptional clinical success rates and superior technology.
        </h3>
      </div>
      <div className="text">
        <p
          aria-label="Columbiaa Hospital's commitment to wellness, innovation, and compassionate care"
          title="Commitment to Wellness, Innovation, and Compassionate Care at Columbiaa Hospital"
        >
          At Columbiaa Multi Specialty Hospital, we open our doors to wellness, innovation, and compassionate care. Here, every patient’s journey is met with expertise, empathy, and the latest in medical technology. We are more than just a hospital; we are a community dedicated to healing, health education, advanced surgical and medical care.
        </p>
      </div>
    </div>
  </div>
</div>

            </div>
          </div>
        </div>
      </div>
     <ContactMarquee/>

      {/* Vision  */}
      <div className="aboutus" style={{ overflowX: "hidden" }} aria-label="About Us Section - Columbiaa Hospital" title="Learn about Columbiaa Hospital's Vision and Goals">
  <div
    className="pattern-layer"
    style={{
      backgroundImage: "url(assets/images/shape/pattern-5.png)",
    }}
    aria-label="Background pattern for Columbiaa Hospital About Us section"
  ></div>
  <div className="auto-container">
    <div className="inner-container">
      <div className="row clearfix">
        <div
          className="col-lg-6 col-md-12 col-sm-12 content-column pl-5"
          data-aos="fade-left"
          aria-label="Vision statement of Columbiaa Hospital"
        >
          <div id="content_block_3">
            <div className="content-box">
              <div className="sec-title">
                <h3
                  aria-label="Columbiaa Hospital's Vision"
                  title="Our Vision to be a leading hospital in Northern Bangalore"
                >
                  Our Vision
                </h3>
              </div>
              <div className="text">
                <p
                  aria-label="Vision statement describing Columbiaa Hospital's goals"
                  title="To be recognized for world-class healthcare and advancements"
                >
                  To be a leading multi-speciality hospital in Northern Bangalore, recognised for world-class healthcare, cutting-edge medical advancements, and a commitment to enhancing lives through exceptional patient care.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-6 col-md-12 col-sm-12 content-column"
          data-aos="fade-right"
          aria-label="Image representing the Vision of Columbiaa Hospital"
        >
          <div id="content_block_2">
            <div className="content-box centred">
              <figure className="image-box">
                <img
                  src="assets/images/about/vision.png"
                  alt="Vision of Columbiaa Hospital, Kasturi Nagar, Bangalore"
                  title="Columbiaa Hospital Vision"
                  aria-label="Image representing the vision of Columbiaa Hospital"
                  style={{
                    border: "3px solid rgb(83,160,212)",
                    borderRadius: "10px",
                  }}
                />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      {/* Mission  */}
      <div className="aboutus" style={{ overflowX: "hidden" }} aria-label="About Us Section - Columbiaa Hospital" title="Columbiaa Hospital's Mission and Services">
  <div
    className="pattern-layer"
    style={{
      backgroundImage: "url(assets/images/shape/pattern-5.png)",
    }}
    aria-label="Background pattern for Columbiaa Hospital About Us section"
  ></div>
  <div className="auto-container">
    <div className="inner-container">
      <div className="row clearfix">
        <div
          className="col-lg-6 col-md-12 col-sm-12 content-column"
          data-aos="fade-right"
          aria-label="Image showing healthcare services at Columbiaa Hospital"
        >
          <div id="content_block_2">
            <div className="content-box centred">
              <figure className="image-box">
                <img
                  src="assets/images/service/ot1.jpeg"
                  alt="Surgical operation theatre at Columbiaa Hospital, Kasturi Nagar, Bangalore"
                  title="Surgical operation theatre at Columbiaa Hospital"
                  style={{ width: "70%" }}
                  aria-label="Columbiaa Hospital operation theatre"
                />
              </figure>
            </div>
          </div>
        </div>
        <div
          className="col-lg-6 col-md-12 col-sm-12 content-column pl-5"
          data-aos="fade-left"
          aria-label="Mission statement of Columbiaa Hospital"
        >
          <div id="content_block_3">
            <div className="content-box">
              <div className="sec-title">
                <h3
                  aria-label="Columbiaa Hospital's Mission"
                  title="Columbiaa Hospital's commitment to compassionate healthcare"
                >
                  Our Mission
                </h3>
              </div>
              <div className="text">
                <p
                  aria-label="Mission statement describing Columbiaa Hospital's goals"
                  title="Patient-centred healthcare through innovation and advanced medical technology"
                >
                  To provide compassionate, patient-centred healthcare through innovation, advanced medical technology, and a team of dedicated professionals, ensuring the highest standards of safety, quality, and excellence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      {/* Managing Director message  */}
      <div
  className="auto-container border rounded shadow py-5 my-5"
  style={{ overflowX: "hidden" }}
  aria-label="Managing Director's Message Section - Columbiaa Hospital"
  title="Message from Mr. Pavan Kumar, Managing Director of Columbiaa Hospital"
>
  <div className="row clearfix">
    <div
      className="col-lg-4 col-md-12 col-sm-12 content-column"
      data-aos="fade-right"
      aria-label="Photograph of Mr. Pavan Kumar, Managing Director - Columbiaa Hospital"
    >
      <div>
        <figure>
          <img
            src="assets/images/about/pavan.png"
            alt="Mr. Pavan Kumar, Managing Director, Columbiaa Hospital"
            title="Mr. Pavan Kumar, Managing Director, Columbiaa Hospital"
            style={{
              borderRadius: "50%",
              border: "5px solid rgb(83,160,212)",
            }}
            aria-label="Photograph of Mr. Pavan Kumar, Managing Director, Columbiaa Hospital"
          />
        </figure>
      </div>
    </div>

    <div
      className="col-lg-8 col-md-12 col-sm-12 content-column pl-5"
      data-aos="fade-left"
      aria-label="Managing Director's Message Section - Columbiaa Hospital"
    >
      <div id="content_block_3">
        <div
          className="content-box"
          aria-label="Message from Mr. Pavan Kumar, Managing Director at Columbiaa Hospital"
        >
          <div className="sec-title">
            <h3
              aria-label="Managing Director's Message Heading"
              title="Message from the Managing Director of Columbiaa Hospital"
            >
              Managing Director's Message
            </h3>
          </div>
          <div className="text">
            <p
              className="pb-5"
              aria-label="Message from Mr. Pavan Kumar, Managing Director, Columbiaa Hospital"
            >
             At <strong>Columbiaa Multi-Speciality Hospital</strong>, I extend a warm welcome to all. Our vision is to elevate healthcare in India by combining medical expertise, advanced technology, and compassionate care. Guided by strong values of integrity, service, and excellence, we believe hospitals exist for healing, trust, and hope. With experienced healthcare professionals and modern infrastructure, we are committed to delivering patient-centred, ethical, and high-quality multi-speciality care.
            </p>
            <p
              className="pb-5"
              aria-label="Message from Mr. Pavan Kumar, Managing Director, Columbiaa Hospital"
            >
             Our focus on quality is reflected in our clinical standards, skilled consultants, and a safe, clean, and patient-friendly environment. We continuously work to improve our services and care experience while ensuring accessibility and reliability. I sincerely thank you for your trust and support, and I invite you to explore our services and share your feedback as we strive to serve you better.
            </p>
            <h5
              aria-label="Mr. Pavan Kumar, Managing Director, Columbiaa Hospital"
              title="Mr. Pavan Kumar, Managing Director, Columbiaa Hospital"
            >
              Mr. Pavan Kumar, Managing Director, Columbiaa Hospital
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      {/* Medical Director message  */}
      <div
  className="auto-container border rounded shadow py-5 mb-5"
  style={{ overflowX: "hidden" }}
  aria-label="Medical Director's Message Section - Columbiaa Hospital"
  title="Message from Dr. H.V. Satish Babu, Medical Director at Columbiaa Hospital"
>
  <div className="row clearfix">
    <div
      className="col-lg-8 col-md-12 col-sm-12 content-column pl-5"
      data-aos="fade-left"
      aria-label="Message from Dr. H.V. Satish Babu, Medical Director at Columbiaa Hospital"
    >
      <div id="content_block_3">
        <div
          className="content-box"
          aria-label="Message from Dr. H.V. Satish Babu, Medical Director at Columbiaa Hospital"
        >
          <div className="sec-title">
            <h3
              aria-label="Medical Director's Message Heading"
              title="Message from the Medical Director, Dr. H.V. Satish Babu, Columbiaa Hospital"
            >
              Medical Director's Message
            </h3>
          </div>
          <div className="text">
            <p
              className="pb-5"
              aria-label="Message from Dr. H.V. Satish Babu, Medical Director, Columbiaa Hospital"
            >
              Excellence in healthcare is our driving force at{" "}
              <strong>Columbiaa Multi-Speciality Hospital</strong>. Our team of
              skilled doctors, nurses, and medical professionals is committed to
              providing comprehensive, evidence-based treatments with a
              personalised approach. We continuously integrate advanced medical
              technology and best practices to enhance patient outcomes and
              improve lives. Trust us for compassionate, high-quality, and safe
              healthcare services. We are not only your healthcare provider but
              also your healthcare partner.
            </p>
            <h5
              aria-label="Dr. H.V. Satish Babu, Senior Consultant Neurosurgeon, Columbiaa Hospital"
              title="Dr. H.V. Satish Babu, Senior Consultant Neurosurgeon, Columbiaa Hospital"
            >
              Dr. H.V. Satish Babu, Senior Consultant Neurosurgeon, Columbiaa
              Hospital
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div
      className="col-lg-4 col-md-12 col-sm-12 content-column"
      data-aos="fade-right"
      aria-label="Photograph of Dr. H.V. Satish Babu, Senior Consultant Neurosurgeon, Columbiaa Hospital"
    >
      <div>
        <figure>
          <img
            src="assets/images/about/hvsb.jpeg"
            alt="Dr. H.V. Satish Babu, Senior Consultant Neurosurgeon, Columbiaa Hospital"
            title="Dr. H.V. Satish Babu, Senior Consultant Neurosurgeon, Columbiaa Hospital"
            style={{
              borderRadius: "50%",
              border: "5px solid rgb(83,160,212)",
            }}
            aria-label="Photograph of Dr. H.V. Satish Babu, Senior Consultant Neurosurgeon"
          />
        </figure>
      </div>
    </div>
  </div>
</div>


      {/* Administrative Director message  */}

      <div
  className="auto-container border rounded shadow py-5 mb-5"
  style={{ overflowX: "hidden" }}
  aria-label="Administrative Director's Message Section - Columbiaa Hospital"
  title="Message from Mr. Anand Babu, Administrative Director at Columbiaa Hospital"
>
  <div className="row clearfix">
    <div
      className="col-lg-8 col-md-12 col-sm-12 content-column pl-5"
      data-aos="fade-left"
      aria-label="Message from Mr. Anand Babu, Administrative Director at Columbiaa Hospital"
    >
      <div id="content_block_3">
        <div
          className="content-box"
          aria-label="Message from Mr. Anand Babu, Administrative Director at Columbiaa Hospital"
        >
          <div className="sec-title">
            <h3
              aria-label="Administrative Director's Message Heading"
              title="Message from the Administrative Director, Mr. Anand Babu, Columbiaa Hospital"
            >
              Administrative Director's Message
            </h3>
          </div>
          <div className="text">
            <p
              className="pb-5"
              aria-label="Message from Mr. Anand Babu, Administrative Director, Columbiaa Hospital"
            >
              At <strong>Columbiaa Multi-Speciality Hospital</strong>, we strive to
              ensure seamless healthcare services by fostering efficiency, quality,
              and patient satisfaction. Our administrative team works tirelessly to
              maintain a patient-friendly environment, ensuring that every individual
              receives timely and compassionate care. We are committed to continuous
              improvement, operational excellence, and making healthcare accessible to
              all.
            </p>
            <h5
              aria-label="Mr. Anand Babu, Administrative Director, Columbiaa Hospital"
              title="Mr. Anand Babu, Administrative Director, Columbiaa Hospital"
            >
              Mr. Anand Babu, Administrative Director, Columbiaa Hospital
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div
      className="col-lg-4 col-md-12 col-sm-12 content-column"
      data-aos="fade-right"
      aria-label="Profile of Mr. Anand Babu, Administrative Director at Columbiaa Hospital"
    >
      <div>
        <figure>
          <img
            src="assets/images/about/anand.jpeg"
            alt="Mr. Anand Babu, Administrative Director, Columbiaa Hospital"
            title="Mr. Anand Babu, Administrative Director, Columbiaa Hospital"
            style={{
              borderRadius: "50%",
              border: "5px solid rgb(83,160,212)",
            }}
            aria-label="Photograph of Mr. Anand Babu, Administrative Director"
          />
        </figure>
      </div>
    </div>
  </div>
</div>

    </>
  );
};

export default About;
